import React from 'react'
import classNames from 'classnames'
import { Icon } from '@pandiafi/design-system'
import { Text } from '@pandiafi/components'
import { useTranslation } from 'react-i18next'

import { TContact } from '../../../common/validations/contractContacts'

import { RoundLink } from 'components/RoundLink'

interface ContactCardProps {
  title: string | null
  contact: TContact
  showName: boolean
  role: string | null
  className?: string
}

export const ContactCard: React.FC<ContactCardProps> = ({
  title,
  contact,
  showName,
  role,
  className,
}) => {
  const { t } = useTranslation(['contact'])
  const callLabel = showName
    ? t('contact:callLabel.withName', {
        name: contact.name,
        phoneNumber: contact.phoneNumber,
      })
    : t('contact:callLabel.withoutName', { phoneNumber: contact.phoneNumber })
  const emailLabel = showName
    ? t('contact:emailLabel.withName', {
        name: contact.name,
        email: contact.email,
      })
    : t('contact:emailLabel.withoutName', { email: contact.email })

  return (
    <div
      className={classNames(
        'flex justify-between items-start gap-4',
        className
      )}
    >
      <div className="min-w-0">
        {title && (
          <Text element="h2" size="l" weight="medium" className="mb-2">
            {title}
          </Text>
        )}
        {showName && <p className="my-1">{contact.name}</p>}
        {contact.phoneNumber && (
          <p className="text-sm lg:text-base my-1">{contact.phoneNumber}</p>
        )}
        <p className="text-sm lg:text-base my-1 underline break-all">
          <a href={`mailto:${contact.email}`}>{contact.email}</a>
        </p>
        {role && <p className="text-xs text-common-gray-6 mt-2">{role}</p>}
      </div>
      <div className="flex gap-3 shrink-0">
        {contact.phoneNumber && (
          <RoundLink
            className="min-tablet:hidden"
            href={`tel:${contact.phoneNumber}`}
            label={callLabel}
          >
            <Icon icon="phone" size="lg" className="w-6" />
          </RoundLink>
        )}
        <RoundLink href={`mailto:${contact.email}`} label={emailLabel}>
          <Icon icon="email" size="lg" className="w-6" />
        </RoundLink>
      </div>
    </div>
  )
}
